import { Flex, Skeleton } from '@bitrise/bitkit';
import { OverviewMetric, OverviewPeriod, TypeMetricUnit } from '@trace/types';
import React, { FunctionComponent, useContext } from 'react';
import { URLStateContext } from '../../URLState/URLState';
import OverviewComparisonItem from './OverviewComparisonItem';
import { getComparisonValues, ComparisonValues } from './getComparisonValues';
import getFormattedValue from '../../../utils/metric/getFormattedValue';

type Props = {
  align?: 'middle' | 'end';
  data?: OverviewMetric;
  isFetching: boolean;
  positiveDelta?: 1 | -1;
  small?: boolean;
  unit: TypeMetricUnit;
};

const titles: Record<keyof ComparisonValues, Record<OverviewPeriod, string>> = {
  allVersionsAverage: {
    daily: 'Last 14 days',
    weekly: 'Last 12 weeks',
    monthly: 'Last 12 months',
  },
  allVersionsLatest: {
    daily: 'Yesterday',
    weekly: 'Last week',
    monthly: 'Last month',
  },
};

const OverviewComparison: FunctionComponent<Props> = ({
  align = 'middle',
  data,
  isFetching,
  positiveDelta,
  unit,
}) => {
  const { overviewPeriod } = useContext(URLStateContext);
  const { allVersionsAverage, allVersionsLatest } = getComparisonValues(data?.app);

  return (
    <Skeleton active={isFetching}>
      <Flex alignChildren={align} direction="horizontal" gap="x8">
        <Flex grow>
          <OverviewComparisonItem
            change={allVersionsLatest.change}
            isFetching={isFetching}
            positiveDelta={positiveDelta}
            title={titles.allVersionsLatest[overviewPeriod]}
            currentValue={getFormattedValue(unit, allVersionsLatest.value)}
          />
        </Flex>

        <Flex grow>
          <OverviewComparisonItem
            change={allVersionsAverage.change}
            isFetching={isFetching}
            positiveDelta={positiveDelta}
            title={titles.allVersionsAverage[overviewPeriod]}
            currentValue={getFormattedValue(unit, allVersionsAverage.value)}
          />
        </Flex>
      </Flex>
    </Skeleton>
  );
};

export default OverviewComparison;
